import React from 'react';
import PropTypes from 'prop-types';
import MainGrid from './MainGrid';
import FilterFormSummary from './FilterFormSummary';
import ErrorComments from '../../pc/common/ErrorComments';
import InfoComments from '../../pc/common/InfoComments';
import * as defaultValue from '../../../constants/common/ConstDefaultValue';
import * as commonLogic from '../../../logic/CommonLogic';
import * as cookies from '../../../logic/Cookies';

/**
 * Content
 */
class Content extends React.Component {

  constructor(props) {
    super(props);
    this.handleOverlayView = this.handleOverlayView.bind(this);
  }

  componentDidMount() {
    this.checker = setInterval(this.props.actions.checkAPICall, defaultValue.CHECK_API_CALL_DELAY);
  }

  componentWillUnmount() {
    clearInterval(this.cheker);
  }

  handleOverlayView(e) {
    // イベントの伝播を停止
    e.stopPropagation();
    let viewMode;
    if (this.props.data.kikanUnit === 'days' || this.props.data.kikanUnit === 'weeks') {
      viewMode = 'day';
    } else if (this.props.data.kikanUnit === 'months') {
      viewMode = 'month';
    } else if (this.props.data.kikanUnit === 'years') {
      viewMode = 'year';
    }
    this.props.comactions.cancelCalendar(viewMode);
  }

  render() {
    // error
    if (this.props.data.error != null) {
      commonLogic.loadingFadeOut();

      return (
        <div id="content" className="fix_height main_content">
          <FilterFormSummary actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
          <div id="main">
            <ErrorComments error={this.props.data.error} />
          </div>
        </div>
      );
    }

    // not found
    if (this.props.data.remainderAPICount > 0 && this.props.data.scrollEnd === false) {
      if (this.props.data.msgID === 'M0004') {
        commonLogic.loadingFadeIn();
      } else {
        commonLogic.loadingFadeOut();
      }

      return (
        <div id="content" className="fix_height main_content">
          <div id="main">
            <FilterFormSummary actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
            <InfoComments msgID={this.props.data.msgID} />
          </div>
        </div>
      );
    }

    // スクロールの場合
    if (this.props.data.scrollEnd === true) {
      commonLogic.loadingFadeIn();
    } else {
      // スクロール位置の調整
      commonLogic.setScrollLeft(cookies.getItem('scrollPosition'));

      commonLogic.loadingFadeOut();
    }

    // 日付OFF・パチンコ
    let mainGrid = <MainGrid data={this.props.data} actions={this.props.actions} />;

    return (
      <div id="content">
        <div className="main_content">
          <FilterFormSummary actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />       
          {mainGrid}
        </div>
      </div>
    );
  }
}

Content.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default Content;
